import IframeCommunicatorService, { InterPagesMessages, MessageTypes } from "@/services/IframeCommunicatorService";

let iframeService = new IframeCommunicatorService();
var contentHeight = document.body.scrollHeight;
// Check for height changes
setInterval(() => {
    var pageHeight = 0;
    // Source: https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript
    if (isEdgeBrowser()) {
        // if is edge, take the height from the documentElementHeight
        // Because when the browser zoom change the document.body.scrollHeight wont update if is Edge browser
        // documentElement.scrollHeight does
        pageHeight = document.documentElement.scrollHeight;
    } else {
        // Take the height from the body.height
        pageHeight = document.body.scrollHeight
    }
    if (contentHeight != pageHeight) {
        contentHeight = pageHeight;
        iframeService.postMessageToParent(new InterPagesMessages(MessageTypes.HeightChange, `${pageHeight}`));
    }
}, 150);

function isEdgeBrowser() {
    return window.navigator.userAgent.indexOf("Edge") > -1;
}